import { IDCart } from "../_icons/idCard";

interface AgeRestrictedProps {
  text: string;
  textClassName?: string;
}

export const AgeRestricted = ({ text, textClassName }: AgeRestrictedProps) => {
  return (
    <div className="flex gap-3 items-center py-2">
      <IDCart />
      <p className={`font-weight-[400] text-[#000000] ${textClassName}`}>
        {text}
      </p>
    </div>
  );
};
